import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("admin_token");
  const url = config.url || "";
  if (token && !url.includes("/auth/login")) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  const dk = localStorage.getItem("device_key");
  if (dk) config.headers["X-Device-Key"] = dk;
  return config;
});

export function getMac() {
  return localStorage.getItem("device_mac");
}
export function setMac(m) {
  localStorage.setItem("device_mac", m);
}
export function getDeviceKey() {
  return localStorage.getItem("device_key");
}
export function setDeviceKey(k) {
  if (k) localStorage.setItem("device_key", k);
}
export function clearDevice() {
  localStorage.removeItem("device_mac");
  localStorage.removeItem("device_key");
}

export function proxied(url) {
  if (!url) return url;
  if (url.startsWith("http://")) {
    return `${process.env.REACT_APP_BACKEND_URL}/api/stream?url=${encodeURIComponent(url)}`;
  }
  return url;
}

export const FALLBACKS = {
  live: "https://images.pexels.com/photos/9750839/pexels-photo-9750839.jpeg",
  movie: "https://images.pexels.com/photos/12838778/pexels-photo-12838778.jpeg",
  series: "https://images.pexels.com/photos/12838778/pexels-photo-12838778.jpeg",
};
